module.exports = __webpack_public_path__ + "img/FLDCOMP_RED.14df972a.svg";